<template>
  <div
    style="
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 3mm;
    page-break-before: always;
    "

    v-show="( primeira_pagina && !eh_primeira_pagina ) ? false : true"
  >
  <!--  + pageIndex 
        + ( primeira_pagina ? 'PP / ' : 'PT / ' )
        + ( eh_primeira_pagina ? 'P1' : 'PN' )
        + ( ( primeira_pagina && !eh_primeira_pagina ) ? ' d-none d-print-none' : '' )" -->
    <tiss-box
      title="GUIA DE SERVIÇO PROFISSIONAL / SERVIÇO AUXILIAR DE DIAGNÓSTICO E TERAPIA - SP/SADT"
      :guiaPrestador="numeroGuia"
      :logo="logoURL"
      :operadora="logoText"
      v-if="spsadt != null"
    >
      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-field
          title="1 - Registro ANS"
          largura="10%"
          :value="registroANS"
        />
        <tiss-field title="3 - Nª Guia Principal" largura="15%" :value="numeroGuiaPrincipal" />
        <tiss-field
          title="4 - Data da Autorização"
          largura="15%"
          :value="dataAutorizacao"
        />
        <tiss-field title="5 - Senha" largura="22%" :value="senha" />
        <tiss-field
          title="6 - Validade da Senha"
          largura="15%"
          :value="dataValidadeAutorizacao"
        />
        <tiss-field
          title="7 - Número da Guia na Operadora"
          largura="17.3%"
          :value="numeroGuiaOperadora"
        />
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title title="Dados do Beneficiário"></tiss-sub-title>
        </div>
      </div>
      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-field
          title="8 - Numero da Carteira"
          largura="17%"
          :value="numeroCarteira"
        ></tiss-field>
        <tiss-field
          title="9 - Validade da Carteira"
          largura="10%"
          :value="validadeCarteira"
        ></tiss-field>
        <tiss-field
          title="10 - Nome"
          largura="30%"
          :value="nomeBeneficario"
        ></tiss-field>
        <tiss-field
          title="89 - Nome Social"
          largura="28%"
          :value="nomeSocialBeneficario"
        ></tiss-field>
        <!-- <tiss-field
          title="11 - Cartão Nacional de Saúde"
          largura="19%"
        ></tiss-field> -->
        <tiss-field
          title="12 - Atendimento a RN"
          largura="10%"
          :value="atendimentoRN"
        ></tiss-field>
      </div>
      <div class="row mx-1" style="margin-bottom: 1px;">

      </div>
      <div class="row">
        <div class="col">
          <tiss-sub-title title="Dados do Solicitante"></tiss-sub-title>
        </div>
      </div>
      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-field
          title="13 - Código na Operadora"
          largura="30%"
          :value="codigoPrestadorNaOperadora"
        />
        <tiss-field
          title="14 - Nome do Contratado"
          largura="67.3%"
          :value="nomeContratado"
        />
      </div>

      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-field
          title="15 - Nome do Profissional"
          largura="30%"
          :value="nomeProfissional"
        />
        <tiss-field
          title="16 - Conselho Profissional"
          largura="14%"
          :value="numeroConselhoProfissional"
        />
        <tiss-field
          title="17 - Número do Conselho"
          largura="15%"
          :value="conselhoProfissional"
        />
        <tiss-field title="18 - UF" largura="6%" :value="UF" />
        <tiss-field title="19 - Código CBO" largura="10%" :value="cbos" />
        <tiss-field
          title="20 - Assinatura do Profissional Solicitante"
          largura="19.4%"
          value
        />
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title
            title="Dados da Solicitação / Procedimentos e Exames Solicitados"
          ></tiss-sub-title>
        </div>
      </div>

      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-field
          title="21 - Caráter do Atendimento  "
          largura="15%"
          :value="caraterAtendimento"
        ></tiss-field>
        <tiss-field
          title="22 - Data da Solicitação"
          largura="15%"
          :value="dataSolicitacao"
        ></tiss-field>
        <tiss-field
          title="23 - Indicação"
          largura="46%"
          :value="indicacao"
        ></tiss-field>
         <tiss-field
          title="90 - Indicador de Cobertura Especial"
          largura="20%"
        ></tiss-field>
      </div>

      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-table
          largura="98%"
          altura="1.8cm"
          :campos="tabelaProcedimentosSolicitados"
          :numeracao="Number('24')"
          :sizeCampos="[2, 3, 12, 2, 2]"
        />
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title
            title="Dados do Contratado Executante"
          ></tiss-sub-title>
        </div>
      </div>

      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-field
          title="29 - Código na Operadora "
          largura="25%"
          :value="codigoPrestadorNaOperadoraExecutante"
        />
        <tiss-field
          title="30 - Nome do Contratado"
          largura="52%"
          :value="nomeContratadoExecutante"
        />
        <tiss-field title="31 - Código CNES" largura="19.6%" :value="cnes" />
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title title="Dados do Atendimento"></tiss-sub-title>
        </div>
      </div>

      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-field
          title="32 - Tipo de Atendimento"
          largura="15%"
          :value="tipoAtendimento"
        />
        <tiss-field
          title="33 - Indicação de Acidente"
          largura="15%"
          :value="indicacaoAcidente"
        />
        <tiss-field
            title="34 - Tipo de Consulta"
            largura="15%"
            :value="tipoConsulta"
        />
        <tiss-field
          title="35 - Motivo de Encerramento deo Atendimento"
          largura="20%"
        />
        <tiss-field
            title="91 - Regime de Atendimento"
            largura="15%"
            :value="regimeAtendimento"
        />
        <tiss-field
            title="92 - Saúde Ocupacional"
            largura="14.5%"
            :value="saudeOcupacional"
        />
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title
            title="Dados da Execução/Procedimentos e Exames Realizados"
          ></tiss-sub-title>
        </div>
      </div>
      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-table
          largura="98%"
          altura="1.8cm"
          :campos="tabelaProcedimentosExecutados"
          :numeracao="Number('36')"
          :sizeCampos="[4, 4, 4, 4, 8, 13, 4, 2, 2, 4, 5, 4]"
          :indice="true"
        />
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title
            title="Identificação do(s) Profissional(is) Executante(s)"
          ></tiss-sub-title>
        </div>
      </div>

      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-table
          largura="98%"
          altura="1.8cm"
          :campos="tabelaProfissionaisExecutantes"
          :numeracao="48"
          :sizeCampos="[2, 2, 4, 7, 3, 3, 1, 3]"
          :indice="true"
        />
      </div>

      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-assinaturas
          :title="[
            '56 - Data de Realização de Procedimentos em Série',
            '57 - Assinatura do Beneficiario ou Responsavel'
          ]"
          largura="98%"
          altura="1.0cm"
          :quantidade="10"
          :colunas="5"
          :datas="( guia && guia.js_datas && guia.js_datas.datas && guia.js_datas.datas.length ) 
            ? guia.js_datas.datas
            : ( ( marcacao && marcacao.atendimento && marcacao.atendimento.js_info && marcacao.atendimento.js_info.datas ) ? marcacao.atendimento.js_info.datas : null )"
        />
      </div>

      <div class="row mx-1" style="margin-bottom: 1px;">
        <tiss-field
          title="58 - Observação/Justificativa"
          largura="98%"
          altura="0.7cm"
          :value="observacao"
          :obrigatorio="false"
        />
      </div>

      <template v-if="1 == 1">
        <div class="row mx-1" style="margin-bottom: 0px;">
          <tiss-field
            title="59 - Total Procedimentos"
            largura="14%"
            :value="valorProcedimentos"
          />
          <tiss-field
            title="60 - Total Taxas e Aluguéis"
            largura="14%"
            :value="valorTaxasAlugueis"
          />
          <tiss-field
            title="61 - Total Materiais"
            largura="14%"
            :value="valorMateriais"
          />
          <tiss-field
            title="62 - Total OPME"
            largura="14%"
            :value="valorOPME"
          />
          <tiss-field
            title="63 - Total Medicamentos"
            largura="14%"
            :value="valorMedicamentos"
          />
          <tiss-field
            title="64 - Total Gases Medicinais"
            largura="14%"
            :value="valorGasesMedicinais"
          />
          <tiss-field
            title="65 - Total Geral"
            largura="9.7%"
            :value="valorGeral"
          />
        </div>

        <div class="row mx-1 mb-0">
          <tiss-field
            title="66 - Data e Assinatura do Responsável pela Autorização"
            largura="32%"
          ></tiss-field>
          <tiss-field
            title="67 - Data e Assinatura do Beneficiário ou  Responsável"
            largura="32%"
          ></tiss-field>
          <tiss-field
            :title="nomeContratadoAssTitulo"
            largura="32.6%"
            :value="nomeContratadoAss"
            fontSize="8pt"
          ></tiss-field>
        </div>
      </template>
      <div class="row">
        <div class="col">
          <tiss-rodape
            :infoId="this.guia.id_atendimento"
            :idExterno="this.guia.st_id_externo"
            :id_guia="this.guia.id_guia"
            :id_atendimento="this.guia.id_atendimento"
            :responsavel="atendimento_usuario()"
            :pageIndex="pageIndex"
            :pageCount="pageCount"
            :marcacao="marcacao"
          ></tiss-rodape>
        </div>
      </div>
    </tiss-box>
  </div>
</template>

<script>
import * as moment from "moment";
import TissTable from "./TissTable.vue";
import TissBox from "./TissBox.vue";
import TissField from "./TissField.vue";
import TissSubTitle from "./TissSubTitle.vue";
import TissAssinaturas from "./TissAssinaturas.vue";
import TissRodape from "./TissRodape";

export default {
  data() {
    return {
      largura: "21cm",
      larguramm: 200
    };
  },
  methods: {
    clargura(perc = 100) {
      let larg = this.larguramm - 20;
      larg = Math.round(larg * (perc / 100));
      return larg + "mm";
    },
    atendimento_usuario() {
      if (this.guia && this.guia.st_login) {
        return this.guia.st_login;
      }

      return null;
    },
    ocultar_valores() {
        return this.guia && this.guia.ocultar_valores;
    }
  },
  computed: {
    nomeContratadoAss: function () {
      if ( !this.nome_contratado_ass ) {
        return "";
      }

      return this.nomeContratadoExecutante;
      },
      nomeContratadoAssTitulo: function () {
      let nome = '68 - Data e Assinatura do Contratado';

      if (this.guia.cnpj_contrato) {
        nome = nome + ': ' + this.$util.formatMask(this.guia.cnpj_contrato, 'cpf-cnpj');
      }

      return nome;
    },
    logoURL: function() {
      if (this.guia && this.guia.logo_url_front) {
        return this.guia.logo_url_front;
      }

      if (this.guia && this.guia.logo_text_front) {
        return null;
      }

      return this.logo
    },
    logoText: function() {
      if (this.guia && this.guia.logo_text_front) {
        return this.guia.logo_text_front;
      }

      return this.operadora ? this.operadora.search : '';
    },

    spsadt: function () {
      if (this.guia != null && this.guia.mensagemTISS != null) {
        return this.guia.mensagemTISS;
      }
      return null;
    },

    procedimentos: function() {
      let array = [];

      if (!this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"].procedimentosExecutados) {
        return array;
      }

      if (
        !Array.isArray(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .procedimentosExecutados.procedimentoExecutado
        )
      ) {
        array[0] = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaSP-SADT"
        ].procedimentosExecutados.procedimentoExecutado;
      } else
        array = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaSP-SADT"
        ].procedimentosExecutados.procedimentoExecutado;
      return array;
    },
    valorPago() {
      let valor = {};
      if (
        Array.isArray(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .valorTotal
        )
      ) {
        valor = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaSP-SADT"
        ].valorTotal[0];
      } else
        valor = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaSP-SADT"
        ].valorTotal;
      return valor;
    },
    registroANS: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .cabecalhoGuia &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .cabecalhoGuia.registroANS
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaSP-SADT"
        ].cabecalhoGuia.registroANS;
      else return "";
    },
    numeroGuia: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .cabecalhoGuia &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .cabecalhoGuia.numeroGuiaPrestador
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaSP-SADT"
        ].cabecalhoGuia.numeroGuiaPrestador;
      else return "";
    },
    numeroGuiaPrincipal: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .cabecalhoGuia &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .cabecalhoGuia.guiaPrincipal
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaSP-SADT"
        ].cabecalhoGuia.guiaPrincipal;
      else return "";
    },
    senha: function() {
      let senha = "";
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAutorizacao &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAutorizacao.senha
      ) {
        senha = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaSP-SADT"
        ].dadosAutorizacao.senha;
      }

      // Truncate
      if(senha.length > 30) senha = senha.substring(0, 30) + '...';

      return senha;
    },
    dataAutorizacao: function() {
      let data = "";

      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAutorizacao &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAutorizacao.dataAutorizacao &&
        !Array.isArray( this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAutorizacao.dataAutorizacao)
      ) {
        data = this.$util.getFormatDate(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosAutorizacao.dataAutorizacao
        );
      }
      return data;
    },
    dataValidadeAutorizacao: function() {
      let dataValidade = "";

      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAutorizacao &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAutorizacao.dataValidadeSenha &&
        !Array.isArray( this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAutorizacao.dataValidadeSenha)
      ) {
        dataValidade = this.$util.getFormatDate(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosAutorizacao.dataValidadeSenha
        );
      }
      return dataValidade;
    },
    numeroGuiaOperadora: function() {
    //   if (
    //     this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
    //        &&
    //     this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
    //       .dadosAutorizacao &&
    //     this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
    //       .dadosAutorizacao.numeroGuiaOperadora
    //   )
    //     return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
    //       "guiaSP-SADT"
    //     ].dadosAutorizacao.numeroGuiaOperadora;
    //   else return "";
     if (this.guia && this.guia.st_numero) {
        return this.guia.st_numero;
      }

      return null;
    },
    numeroCarteira: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosBeneficiario &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosBeneficiario.numeroCarteira
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosBeneficiario.numeroCarteira
        : "";
    },
    validadeCarteira: function() {
      if (this.guia.dt_validade_carteira) {
        return this.$util.getFormatDate(
          this.guia.dt_validade_carteira,
          "DD/MM/YYYY"
        );
      }
      return "";
    },
    atendimentoRN: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosBeneficiario &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosBeneficiario.atendimentoRN
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosBeneficiario.atendimentoRN
        : "";
    },
    nomeBeneficario: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosBeneficiario &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosBeneficiario.nomeBeneficiario
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosBeneficiario.nomeBeneficiario
        : "";
    },
    nomeSocialBeneficario: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosBeneficiario &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosBeneficiario.nomeSocialBeneficiario &&
        !Array.isArray(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
              .dadosBeneficiario.nomeSocialBeneficiario
        )
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosBeneficiario.nomeSocialBeneficiario
        : "";
    },
    codigoPrestadorNaOperadora: function() {
      let codPrestador = "";
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.contratadoSolicitante
      ) {
        if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosSolicitante.contratadoSolicitante.cnpjContratado
        ) {
          codPrestador = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaSP-SADT"
          ].dadosSolicitante.contratadoSolicitante.cnpjContratado;
        } else if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosSolicitante.contratadoSolicitante.cpfContratado
        ) {
          codPrestador = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaSP-SADT"
          ].dadosSolicitante.contratadoSolicitante.cpfContratado;
        } else if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosSolicitante.contratadoSolicitante.codigoPrestadorNaOperadora
        ) {
          codPrestador = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaSP-SADT"
          ].dadosSolicitante.contratadoSolicitante.codigoPrestadorNaOperadora;
        }
      }
      return codPrestador;
    },
    nomeContratado: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.contratadoSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.contratadoSolicitante.nomeContratado
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosSolicitante.contratadoSolicitante.nomeContratado
        : "";
    },
    nomeProfissional: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.profissionalSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.profissionalSolicitante.nomeProfissional
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosSolicitante.profissionalSolicitante.nomeProfissional
        : "";
    },
    numeroConselhoProfissional: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.profissionalSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.profissionalSolicitante.conselhoProfissional
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosSolicitante.profissionalSolicitante.conselhoProfissional
        : "";
    },
    conselhoProfissional: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.profissionalSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.profissionalSolicitante.numeroConselhoProfissional
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosSolicitante.profissionalSolicitante.numeroConselhoProfissional
        : "";
    },
    UF: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.profissionalSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.profissionalSolicitante.UF
        ? this.$util.siglaUF(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaSP-SADT"
            ].dadosSolicitante.profissionalSolicitante.UF
          )
        : "";
    },

    cbos: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.profissionalSolicitante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitante.profissionalSolicitante.CBOS
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosSolicitante.profissionalSolicitante.CBOS
        : "";
    },

    dataSolicitacao: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosSolicitacao &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitacao.dataSolicitacao
        ? this.$util.getFormatDate(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaSP-SADT"
            ].dadosSolicitacao.dataSolicitacao,
            "DD/MM/YYYY"
          )
        : "";
    },
    caraterAtendimento: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosSolicitacao &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitacao.caraterAtendimento
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosSolicitacao.caraterAtendimento
        : "";
    },

    indicacao: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitacao &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosSolicitacao.indicacaoClinica
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaSP-SADT"
        ].dadosSolicitacao.indicacaoClinica;
      return "";
    },

    codigoPrestadorNaOperadoraExecutante: function() {
      let txt = "";
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosExecutante.contratadoExecutante
      ) {
        if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosExecutante.contratadoExecutante.cnpjContratado
        )
          txt = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaSP-SADT"
          ].dadosExecutante.contratadoExecutante.cnpjContratado;
        else if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosExecutante.contratadoExecutante.codigoPrestadorNaOperadora
        ) {
          txt = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaSP-SADT"
          ].dadosExecutante.contratadoExecutante.codigoPrestadorNaOperadora;
        } else if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosExecutante.contratadoExecutante.cpfContratado
        ) {
          txt = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaSP-SADT"
          ].dadosExecutante.contratadoExecutante.cpfContratado;
        } else if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosExecutante.contratadoExecutante.cpfContratado
        ) {
          txt = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaSP-SADT"
          ].dadosExecutante.contratadoExecutante.cpfContratado;
        }
      }
      return txt;
    },
    nomeContratadoExecutante: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosExecutante.contratadoExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosExecutante.contratadoExecutante.nomeContratado
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosExecutante.contratadoExecutante.nomeContratado
        : "";
    },
    cnes: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosExecutante.CNES &&
          !Array.isArray(this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosExecutante.CNES)
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosExecutante.CNES
        : "";
    },
    dataExecução: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].procedimentosExecutados &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .procedimentosExecutados.procedimentoExecutado &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .procedimentosExecutados.procedimentoExecutado.dataExecução
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .procedimentosExecutados.procedimentoExecutado.dataExecução
        : "";
    },
    indicacaoAcidente: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosAtendimento &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAtendimento.indicacaoAcidente
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosAtendimento.indicacaoAcidente
        : "";
    },
    regimeAtendimento: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosAtendimento &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAtendimento.regimeAtendimento
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosAtendimento.regimeAtendimento
        : "";
    },
    saudeOcupacional: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosAtendimento &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAtendimento.saudeOcupacional
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosAtendimento.saudeOcupacional
        : "";
    },
    tipoConsulta: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosAtendimento &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAtendimento.tipoConsulta &&
        !Array.isArray(this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAtendimento.tipoConsulta)
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosAtendimento.tipoConsulta
        : "";
    },
    tipoAtendimento: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].dadosAtendimento &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .dadosAtendimento.tipoAtendimento
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .dadosAtendimento.tipoAtendimento
        : "";
    },

    valorProcedimentos: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .valorTotal.valorProcedimentos
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaSP-SADT"
            ].valorTotal.valorProcedimentos
          )
        : "";
    },
    valorDiarias: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .valorTotal.valorDiarias
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaSP-SADT"
            ].valorTotal.valorDiarias
          )
        : "";
    },
    valorTaxasAlugueis: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .valorTotal.valorTaxasAlugueis
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaSP-SADT"
            ].valorTotal.valorTaxasAlugueis
          )
        : "";
    },
    valorMateriais: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .valorTotal.valorMateriais
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaSP-SADT"
            ].valorTotal.valorMateriais
          )
        : "";
    },
    valorMedicamentos: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .valorTotal.valorMedicamentos
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaSP-SADT"
            ].valorTotal.valorMedicamentos
          )
        : "";
    },
    valorOPME: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .valorTotal.valorOPME
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaSP-SADT"
            ].valorTotal.valorOPME
          )
        : "";
    },
    valorGasesMedicinais: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .valorTotal.valorGasesMedicinais
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaSP-SADT"
            ].valorTotal.valorGasesMedicinais
          )
        : "";
    },
    valorGeral: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaSP-SADT"
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .valorTotal.valorTotalGeral
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaSP-SADT"
            ].valorTotal.valorTotalGeral
          )
        : "";
    },
    tabelaProcedimentosSolicitados: function() {
      let campos = [];
      let procedimentos = this.procedimentos;

      for (let i = 0; i < procedimentos.length; i++) {

        if (procedimentos[i] && procedimentos[i].esconder ) {
          continue;
        }

        let tmp = {};

        if ( !procedimentos[i] ) {
          continue;
        }

        if (
          procedimentos[i].procedimento &&
          procedimentos[i].procedimento.codigoTabela
        ) {
          tmp["Tabela"] = procedimentos[i].procedimento.codigoTabela;
        } else tmp["Tabela"] = "";

        if (procedimentos[i].procedimento.codigoProcedimento)
          tmp["Codigo do Procedimento"] =
            procedimentos[i].procedimento.codigoProcedimento;
        else tmp["Codigo do Procedimento"] = "";

        if (
          procedimentos[i].procedimento &&
          procedimentos[i].procedimento.descricaoProcedimento
        )
          tmp["Descrição"] =
            procedimentos[i].procedimento.descricaoProcedimento;
        else tmp["Descrição"] = "";

        if (procedimentos[i].quantidadeExecutada) {
          tmp["Qt. Solic."] = procedimentos[i].quantidadeExecutada;
        } else tmp["Qt. Solic."] = "";

        if (procedimentos[i].quantidadeExecutada) {
          tmp["Qt. Autor."] = procedimentos[i].quantidadeExecutada;
        } else tmp["Qt. Autor."] = "";

        campos.push(tmp);
      }

      return campos;
    },
    tabelaProcedimentosExecutados: function() {
      let campos = [];
      // let procedimentos = this.spsadt.prestadorParaOperadora.loteGuias
      //   .guiasTISS["guiaSP-SADT"].procedimentosExecutados.procedimentoExecutado;
      let procedimentos = this.procedimentos;
      for (let i = 0; i < procedimentos.length; i++) {
        let tmp = {};

        if ( !procedimentos[i] )
          continue;

        if (procedimentos[i].dataExecucao) {
          tmp["Data"] = this.$util.getFormatDate(
            procedimentos[i].dataExecucao,
            "DD/MM/YYYY"
          );
        } else tmp["Data"] = "";

        if (procedimentos[i].horaInicial)
          tmp["Hora Inicial"] = moment(
            procedimentos[i].horaInicial,
            "HH:mm:ss"
          ).format("HH:mm");
        else tmp["Hora Inicial"] = "";

        if (procedimentos[i].horaFinal)
          tmp["Hora Final"] = moment(
            procedimentos[i].horaFinal,
            "HH:mm:ss"
          ).format("HH:mm");
        else tmp["Hora Final"] = "";

        if (
          procedimentos[i].procedimento &&
          procedimentos[i].procedimento.codigoTabela
        )
          tmp["Tabela"] = procedimentos[i].procedimento.codigoTabela;
        else tmp["Tabela"] = "";

        if (procedimentos[i].procedimento.codigoProcedimento)
          tmp["Codigo do Procedimento"] =
            procedimentos[i].procedimento.codigoProcedimento;
        else tmp["Codigo do Procedimento"] = "";

        if (
          procedimentos[i].procedimento &&
          procedimentos[i].procedimento.descricaoProcedimento
        )
          tmp["Descrição"] =
            procedimentos[i].procedimento.descricaoProcedimento;
        else tmp["Descrição"] = "";

        if (procedimentos[i] && procedimentos[i].quantidadeExecutada)
          tmp["Quantidade"] = procedimentos[i].quantidadeExecutada;
        else tmp["Quantidade"] = "";

        if (procedimentos[i].viaAcesso) tmp["Via"] = procedimentos[i].viaAcesso;
        else tmp["Via"] = "";

        if (procedimentos[i].tecnicaUtilizada)
          tmp["Tec."] = procedimentos[i].tecnicaUtilizada;
        else tmp["Tec."] = "";

        if (procedimentos[i].reducaoAcrescimo)
          tmp["%Red./Acresc."] = this.$util.formatMoeda(
            procedimentos[i].reducaoAcrescimo
          ) ;
        else tmp["%Red./Acresc."] = "";

        if (procedimentos[i].valorUnitario)
          tmp["Valor Unitario"] = !this.ocultar_valores() ? this.$util.formatMoeda(
            procedimentos[i].valorUnitario
          ) : '';
        else tmp["Valor Unitario"] = "";

        if (procedimentos[i].valorTotal)
          tmp["Valor Total"] = !this.ocultar_valores() ? this.$util.formatMoeda(
            procedimentos[i].valorTotal
          ) : '';
        else tmp["Valor Total"] = "";

        campos.push(tmp);
      }

      return campos;
    },
    tabelaProfissionaisExecutantes: function() {
      let campos = [];
      // let procedimentos = this.spsadt.prestadorParaOperadora.loteGuias
      //   .guiasTISS["guiaSP-SADT"].procedimentosExecutados.procedimentoExecutado;
      let procedimentos = this.procedimentos;
      for (var i = 0; i < procedimentos.length; i++) {
        if ( !procedimentos[i] )
          continue;
        
        let equipesSadt = [];
        if(Array.isArray(procedimentos[i].equipeSadt)) {
            equipesSadt = procedimentos[i].equipeSadt;
        } else {
            equipesSadt.push(procedimentos[i].equipeSadt);
        }
        
        for (var j = 0; j < equipesSadt.length; j++) {
            let tmp = {};
            tmp["Seq. Ref."] = (i + 1).toString();
            
            const equipeSadt = equipesSadt[j];
            if(!equipeSadt) {
                continue;
            }

            if (equipeSadt.grauPart) {
            tmp["Grau Part."] = equipeSadt.grauPart;
            } else tmp["Grau Part."] = "";

            if (equipeSadt.codProfissional.cpfContratado) {
            tmp["Código na Operadora/CPF"] =
                equipeSadt.codProfissional.cpfContratado;
            } else if (equipeSadt.codProfissional.codigoPrestadorNaOperadora) {
                tmp["Código na Operadora/CPF"] =
                equipeSadt.codProfissional.codigoPrestadorNaOperadora;
            } else tmp["Código na Operadora/CPF"] = "";

            if (equipeSadt.nomeProf)
            tmp["Nome do Profissional"] = equipeSadt.nomeProf;
            else tmp["Nome do Profissional"] = "";

            if (equipeSadt.conselho)
            tmp["Conselho Profissional"] = equipeSadt.conselho;
            else tmp["Conselho Profissional"] = "";

            if (equipeSadt.numeroConselhoProfissional)
            tmp["Número no Conselho"] =
                equipeSadt.numeroConselhoProfissional;
            else tmp["Número no Conselho"] = "";

            if (equipeSadt && equipeSadt.UF)
            tmp["UF"] = this.$util.siglaUF(equipeSadt.UF);
            else tmp["UF"] = "";

            if (equipeSadt && equipeSadt.CBOS)
            tmp["Código CBO"] = equipeSadt.CBOS;
            else tmp["Código CBO"] = "";

            campos.push(tmp);
        }

        // if (procedimentos[i].equipeSadt.grauPart) {
        //   tmp["Grau Part."] = procedimentos[i].equipeSadt.grauPart;
        // } else tmp["Grau Part."] = "";

        // if (procedimentos[i].equipeSadt.codProfissional.cpfContratado) {
        //   tmp["Código na Operadora/CPF"] =
        //     procedimentos[i].equipeSadt.codProfissional.cpfContratado;
        // } else if (procedimentos[i].equipeSadt.codProfissional.codigoPrestadorNaOperadora) {
        //     tmp["Código na Operadora/CPF"] =
        //       procedimentos[i].equipeSadt.codProfissional.codigoPrestadorNaOperadora;
        // } else tmp["Código na Operadora/CPF"] = "";

        // if (procedimentos[i].equipeSadt.nomeProf)
        //   tmp["Nome do Profissional"] = procedimentos[i].equipeSadt.nomeProf;
        // else tmp["Nome do Profissional"] = "";

        // if (procedimentos[i].equipeSadt.conselho)
        //   tmp["Conselho Profissional"] = procedimentos[i].equipeSadt.conselho;
        // else tmp["Conselho Profissional"] = "";

        // if (procedimentos[i].equipeSadt.numeroConselhoProfissional)
        //   tmp["Número no Conselho"] =
        //     procedimentos[i].equipeSadt.numeroConselhoProfissional;
        // else tmp["Número no Conselho"] = "";

        // if (procedimentos[i].equipeSadt && procedimentos[i].equipeSadt.UF)
        //   tmp["UF"] = this.$util.siglaUF(procedimentos[i].equipeSadt.UF);
        // else tmp["UF"] = "";

        // if (procedimentos[i].equipeSadt && procedimentos[i].equipeSadt.CBOS)
        //   tmp["Código CBO"] = procedimentos[i].equipeSadt.CBOS;
        // else tmp["Código CBO"] = "";

        // campos.push(tmp);
      }

      return campos;
    },

     observacao: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"] &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
          .observacao
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaSP-SADT"]
            .observacao
        : "";
    },

    styleRotate() {
      if (this.rotate)
        return "transform: rotate(270deg) translate(-376mm, 0); transform-origin: 0 0; margin: 0; padding: 0;";
      //return "-webkit-transform: rotate(-90deg) !important;-moz-transform:rotate(-90deg) !important;-o-transform: rotate(-90deg) !important; -ms-transform:rotate(-90deg) !important;position:relative;top:15cm;left:0px; padding:1cm;";
      //return "-webkit-transform: rotate(-90deg) scale(.65,.65) !important;-moz-transform:rotate(-90deg) scale(.58,.58)!important;-o-transform: rotate(-90deg) scale(.58,.58)!important; -ms-transform:rotate(-90deg) scale(.6,.6)!important;position:relative;top:10cm;left:0px; padding:1cm;";
      return "";
    }
  },
  props: ["guia", "logo", "operadora", "rotate", "nome_contratado_ass", "pageIndex", "pageCount", "eh_primeira_pagina", "primeira_pagina", "marcacao"],
  components: {
    TissTable,
    TissBox,
    TissField,
    TissSubTitle,
    TissAssinaturas,
    TissRodape
  }
};
</script>

<style>
</style>
